import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/top_img.jpg'
import _imports_1 from '../assets/order.png'
import _imports_2 from '../assets/arrow_right.png'
import _imports_3 from '../assets/purchase.png'
import _imports_4 from '../assets/production.png'
import _imports_5 from '../assets/arrow_ru.png'
import _imports_6 from '../assets/arrow_double.png'
import _imports_7 from '../assets/transport.png'
import _imports_8 from '../assets/arrow_rd.png'
import _imports_9 from '../assets/arrow_down.png'
import _imports_10 from '../assets/finance.png'
import _imports_11 from '../assets/search.png'


const _withScopeId = n => (_pushScopeId("data-v-db6b5eaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "top-image",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "user-info" }
const _hoisted_4 = { class: "username" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 退出 ")
const _hoisted_6 = { class: "main" }
const _hoisted_7 = { class: "line1" }
const _hoisted_8 = ["data-count"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "合同订单", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow right",
  src: _imports_2
}, null, -1))
const _hoisted_13 = ["data-count"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "部件采购", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow right",
  src: _imports_2
}, null, -1))
const _hoisted_18 = ["data-count"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "生产管理", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "line2-up" }
const _hoisted_23 = { class: "line2" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow double",
  src: _imports_6
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-space" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "运输管理", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow right",
  src: _imports_2
}, null, -1))
const _hoisted_30 = ["data-count"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检测管理", -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = { class: "line2-down" }
const _hoisted_35 = { class: "line3" }
const _hoisted_36 = ["data-count"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_10 }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "财务管理", -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = ["data-count"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "派单工单", -1))
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = ["data-count"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "售后工单", -1))
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = { class: "line3" }
const _hoisted_49 = ["data-count"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_11 }, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "经理查询", -1))
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "售后打卡", -1))
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "拜访记录", -1))
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = { class: "line3" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "履约保函", -1))
const _hoisted_62 = [
  _hoisted_60,
  _hoisted_61
]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "投标保证金", -1))
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, "美卓伦仪表（常州）有限公司", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, "当前用户：" + _toDisplayString(_ctx.username), 1),
      _createVNode(_component_van_button, {
        class: "logout-btn",
        round: "",
        plain: "",
        type: "primary",
        onClick: _ctx.logout
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_icon, { name: "revoke" }),
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(["step-icon", `step-icon ${_ctx.htddCount&&_ctx.htddCount!='0'?'badge-item':''}`]),
          "data-count": _ctx.htddCount,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navTo(_ctx.urlList.order)))
        }, _hoisted_11, 10, _hoisted_8),
        _hoisted_12,
        _createElementVNode("div", {
          ref: "rightStep",
          class: _normalizeClass(`step-icon ${_ctx.bjcgCount&&_ctx.bjcgCount!='0'?'badge-item':''}`),
          "data-count": _ctx.bjcgCount,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navTo(_ctx.urlList.purchase)))
        }, _hoisted_16, 10, _hoisted_13),
        _hoisted_17,
        _createElementVNode("div", {
          class: _normalizeClass(`step-icon ${_ctx.scjcCount&&_ctx.scjcCount!='0'?'badge-item':''}`),
          "data-count": _ctx.scjcCount,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navTo(_ctx.urlList.production)))
        }, _hoisted_21, 10, _hoisted_18)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("img", {
          class: "arrow small",
          style: _normalizeStyle({marginRight: `calc(${_ctx.rightPostion} - 25px)`}),
          src: _imports_5
        }, null, 4),
        _createElementVNode("img", {
          class: "arrow small",
          style: _normalizeStyle({marginRight: `calc(${_ctx.rightPostion} - 25px)`}),
          src: _imports_6
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _hoisted_25,
        _createElementVNode("div", {
          ref: "centerStep",
          class: "step-icon",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navTo(_ctx.urlList.transport)))
        }, _hoisted_28, 512),
        _hoisted_29,
        _createElementVNode("div", {
          class: _normalizeClass(`step-icon ${_ctx.jcCount&&_ctx.jcCount!='0'?'badge-item':''}`),
          "data-count": _ctx.jcCount,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navTo(_ctx.urlList.production)))
        }, _hoisted_33, 10, _hoisted_30)
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("img", {
          class: "arrow small",
          style: _normalizeStyle({marginRight: `calc(${_ctx.rightPostion} - 25px)`}),
          src: _imports_8
        }, null, 4),
        _createElementVNode("img", {
          class: "arrow small",
          style: _normalizeStyle({marginRight: `calc(${_ctx.rightPostion} - 25px)`}),
          src: _imports_9
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", {
          class: _normalizeClass(`step-icon ${_ctx.cwglCount&&_ctx.cwglCount!='0'?'badge-item':''}`),
          "data-count": _ctx.cwglCount,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navTo(_ctx.urlList.finance)))
        }, _hoisted_39, 10, _hoisted_36),
        _createElementVNode("div", {
          class: _normalizeClass(`step-icon ${_ctx.dispatchCount&&_ctx.dispatchCount!='0'?'badge-item':''}`),
          "data-count": _ctx.dispatchCount,
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navTo(_ctx.urlList.dispatch)))
        }, _hoisted_43, 10, _hoisted_40),
        _createElementVNode("div", {
          class: _normalizeClass(`step-icon ${_ctx.afterSalesCount&&_ctx.afterSalesCount!='0'?'badge-item':''}`),
          "data-count": _ctx.afterSalesCount,
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.navTo(_ctx.urlList.afterSales)))
        }, _hoisted_47, 10, _hoisted_44)
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", {
          class: _normalizeClass(`step-icon ${_ctx.jlcxCount&&_ctx.jlcxCount!='0'?'badge-item':''}`),
          "data-count": _ctx.jlcxCount,
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.navTo(_ctx.urlList.managerSearch)))
        }, _hoisted_52, 10, _hoisted_49),
        _createElementVNode("div", {
          class: "step-icon",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.navTo(_ctx.urlList.afterSalesCheckIn)))
        }, _hoisted_55),
        _createElementVNode("div", {
          class: _normalizeClass(`step-icon `),
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.navTo(_ctx.urlList.visitRecord)))
        }, _hoisted_58)
      ]),
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", {
          class: "step-icon",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.navTo(_ctx.urlList.performanceSecurity)))
        }, _hoisted_62),
        _createElementVNode("div", {
          class: _normalizeClass(`step-icon `),
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.navTo(_ctx.urlList.bidSecurity)))
        }, _hoisted_65)
      ])
    ]),
    _hoisted_66
  ]))
}